/** Online booking payments: the add-on settings, an appointment's money, refunds. Conventions: see `common.ts`. */
const bookingPayments: Record<string, string> = {
  open: 'Booking payments',
  title: 'Online booking payments',
  loading: 'Loading payment settings…',
  load_error: 'Payment settings could not be loaded. Please try again.',
  intro:
    'Take money when customers book: the full price, a deposit, or let them choose. Unpaid bookings hold the slot for a few minutes, then free it.',
  saved: 'Booking payment settings saved',
  save_error: 'Could not save the payment settings.',

  enabled: 'Take payments when customers book',
  enabled_hint: 'Off: bookings stay free and prices are only shown, as before.',
  default_mode: 'Default for services',
  default_mode_hint: 'Each service can choose its own on the Services page.',
  'mode.FULL': 'Full payment',
  'mode.DEPOSIT': 'Deposit',
  'mode.PAY_AT_VENUE': 'Pay at venue',
  'mode.CUSTOMER_CHOICE': 'Customer chooses',
  'mode.PACKAGE': 'Package credit',

  deposit_type: 'Deposit type',
  'deposit.FIXED': 'Fixed amount (₹)',
  'deposit.PERCENT': 'Percent of price',
  deposit_percent: 'Deposit (%)',
  deposit_amount: 'Deposit (₹)',
  deposit_hint: 'Used by services that take a deposit and do not set their own.',

  hold_minutes: 'Hold the slot for (minutes)',
  hold_minutes_hint: 'How long a customer has to pay before the slot frees up.',
  refund_cutoff_hours: 'Free cancellation until (hours before)',
  refund_cutoff_hours_hint: 'Cancelled earlier than this: a full refund.',
  late_cancel: 'Cancelled later than that',
  'late.FULL_REFUND': 'Refund in full anyway',
  'late.KEEP_DEPOSIT': 'Keep the deposit, refund the rest',
  'late.NO_REFUND': 'No refund',
  confirm_on_payment: 'Confirm paid bookings automatically',
  confirm_on_payment_hint: 'Off: a paid booking still waits for you to confirm it.',

  'gateway.missing': 'Connect Razorpay before you switch this on - the money goes straight to your account.',
  'gateway.connect': 'Go to Payments',

  'upsell.title': 'Online booking payments are not on your plan',
  'upsell.description':
    'Upgrade to take full payments or deposits when customers book, and to sell session packages.',
  'upsell.see_plans': 'See plans',

  'errors.deposit_percent': 'Enter a percent above 0 and up to 100.',
  'errors.deposit_fixed': 'Enter an amount above ₹0.',
  'errors.hold': 'Enter whole minutes between {min} and {max}.',
  'errors.cutoff': 'Enter whole hours between {min} and {max}.',

  'payment_status.NOT_REQUIRED': 'Nothing to pay online',
  'payment_status.AWAITING': 'Waiting for payment',
  'payment_status.PAID': 'Paid',
  'payment_status.DEPOSIT_PAID': 'Deposit paid',
  'payment_status.PARTIALLY_REFUNDED': 'Partly refunded',
  'payment_status.REFUNDED': 'Refunded',
  'payment_status.FAILED': 'Payment failed',
  'payment_status.REFUND_FAILED': 'Refund failed',

  'panel.title': 'Payment',
  'panel.mode': 'How it is paid',
  'panel.status': 'Payment status',
  'panel.total': 'Price',
  'panel.paid': 'Paid online',
  'panel.due_at_venue': 'To collect at the visit',
  'panel.refunded': 'Refunded',
  'panel.package': 'Package',
  'panel.package_used': 'One session of a package',
  'panel.held_until': 'Slot held until {time} while the customer pays.',

  'refund.open': 'Refund {amount}',
  'refund.title': 'Refund this appointment',
  'refund.intro': '{name} paid {amount} online that has not been refunded. The appointment itself does not change.',
  'refund.amount': 'Amount to refund (₹)',
  'refund.amount_hint': 'Up to {amount}.',
  'refund.amount_error': 'Enter an amount above ₹0 and up to {amount}.',
  'refund.reason': 'Reason (optional)',
  'refund.reason_placeholder': 'Doctor was running late',
  'refund.button': 'Refund {amount}',
  'refund.done': '{amount} refunded',
  'refund.error': 'The refund did not go through.',
  'refund.on_cancel': 'Refund {amount} to the customer',
  'refund.on_cancel_hint': 'Untick to keep the money - for a late cancellation your policy covers.',
  'refund.refused': 'Razorpay did not accept the refund: {reason}',
  'refund.refused_hint': 'The refund box is now unticked. Cancel without it, then refund the customer from your Razorpay dashboard.',
};

export default bookingPayments;
